import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { Close } from '@mui/icons-material'
import { Box } from '@mui/system'
import { Button, Container, Divider, IconButton, Modal, TextField, Typography } from '@mui/material'

import depositImg from 'assets/images/depositAccount/dep.svg'
import { useNavigate } from 'react-router-dom'

export const DepositAccontPopUp = ({ open, handleClose, callbackFunction }) => {

    const [value, setValue] = useState(null)

    const navigate = useNavigate()


    return createPortal(<Modal
        sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        }}
        open={open}
        onClose={() => handleClose(false)}>
        <Box sx={{
            alignItems: 'center',
            background: '#fff',
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            width: { xs: '80%', lg: '400px' },
            // px: 5,
            pb: 2.5
        }}>
            <Box sx={{
                alignItems: 'center',
                boxSizing: 'border-box',
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                position: 'relative',
                p: 1,
                width: '100%',
            }}>
                <IconButton onClick={() => handleClose(false)}><Close /></IconButton>
                <Typography fontSize={15} fontWeight='bold'>شارژ کیف پول</Typography>
                <IconButton sx={{ opacity: 0 }} onClick={() => handleClose(false)}><Close /></IconButton>
            </Box>

            <Divider flexItem sx={{ mt: 0, mb: 1 }} />

            <Container maxWidth='md' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                <img src={depositImg} width='150px' height='115px' />

                <Typography fontSize={15} fontWeight='600' gutterBottom>مبلغ مورد نظر را وارد کنید</Typography>

                <TextField
                    onChange={({ target: { value } }) => setValue(value)}
                    fullWidth
                    margin='normal'
                    placeholder='تومان'
                    variant="outlined"
                    value={value}
                    type='number'
                />

                <Button
                    disabled={!value}
                    color='primary'
                    variant='contained'
                    fullWidth
                    onClick={() => callbackFunction(value)}
                    sx={{ mt: 2 }}

                >
                    <Typography>پرداخت</Typography>
                </Button>




            </Container>
        </Box>

    </Modal>, document.body)
}
